module.exports = __webpack_public_path__ + "static/media/octorion-pc.8a2d085d.svg";